<template>
  <section class="form-underwriting width-700">
    <el-form
      ref="form"
      :rules="rules"
      class="form-container"
      :model="formData">
      <div class="form-item form-half">
        <span>Type of Insured</span>
        <el-form-item
          prop="type_of_insured">
          <v-select
            v-model="formData.type_of_insured	"
            :list="type_of_insured_list" />
        </el-form-item>
      </div>
      <template v-if="formData.type_of_insured == 1">
        <div class="form-item form-half">
          <span>Age</span>
          <el-form-item
            prop="age_id">
            <v-select
              v-model="formData.age_id"
              :list="localAllOptions.adult_age" />
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>Occupation</span>
          <el-form-item
            ref="occ_id"
            prop="occ_id">
            <v-select
              v-model="formData.occ_id"
              :list="localAllOptions.occupation" />
          </el-form-item>
        </div>
      </template>
      <template v-else>
        <div class="form-half form-item">
          <div class="form-item  button-popover">
            <span>Number of Insured Person(s)</span>
            <el-form-item
              prop="person_form">
              <el-input
                v-popover:popover1
                :value="numOfTraveller"
                suffix-icon="el-icon-d-caret"
              >
              </el-input>
            </el-form-item>
          </div>
          <el-popover
            ref="popover1"
            v-model="visible"
            placement="bottom"
            width="440"
            trigger="click">
            <div class="flex-sb">
              <div class="form-item form-half">
                <span>Adult</span>
                <el-form-item
                  prop="no_of_adult">
                  <v-input-number
                    v-model="temp_pa.no_of_adult"
                    :max="2"
                    :min="1"/>
                </el-form-item>
              </div>
              <div
                class="form-item form-half">
                <span>Children</span>
                <el-form-item
                  prop="no_of_child">
                  <v-input-number
                    v-model="temp_pa.no_of_child"
                    :max="10"
                    :min="0" />
                </el-form-item>
              </div>
            </div>
            <div class="form-item flex-center">
              <v-button
                green
                :disabled="no_of_pa < 2"
                @click="handlerPaList">Confirm</v-button>
            </div>
          </el-popover>
        </div>
        <template
          v-for="(item, index) in formData.nm_pa_list">
          <div
            :key="index"
            class="form-half form-item">
            <div class="form-item  button-popover">
              <el-form-item
                :ref="`nm_pa_list.${index}.showValue`"
                :rules="rules.showValue"
                :prop="`nm_pa_list.${index}.showValue`">
                <el-input
                  v-popover="`popover_adult` + index"
                  :value="item.showValue"
                  :placeholder="item.age_type == 1? adult_placeholder : child_placeholder"
                  suffix-icon="el-icon-d-caret"
                >
                </el-input>
              </el-form-item>
            </div>
            <el-popover
              :ref="'popover_adult' + index"
              v-model="item.visible"
              placement="bottom"
              width="440"
              trigger="click">
              <div>
                <div class="form-item">
                  <span>Child Age</span>
                  <el-form-item>
                    <v-select
                      v-model="item.age_id"
                      :index="index"
                      :list="age(item.age_type)"
                      @change="handleChangeAge" />
                  </el-form-item>
                </div>
                <div class="form-item">
                  <span>Occupation</span>
                  <el-form-item>
                    <v-select
                      v-model="item.occ_id"
                      :disabled="item.age_type==2"
                      :list="occupation(item.age_type)" />
                  </el-form-item>
                </div>
              </div>
              <div class="form-item flex-center">
                <v-button
                  green
                  :disabled="item.age_type==2&&item.age_id<0"
                  @click="handleAdultConfirm(item, index)">Confirm</v-button>
              </div>
            </el-popover>
          </div>
        </template>
      </template>
      <!-- <div class="form-item">
        <span>Plan Level</span>
        <el-form-item
          prop="plan_tier"
        >
          <v-radio-group
            v-model="formData.plan_tier"
            :border="true"
            :list="planLevelOptions"
          />
        </el-form-item>
      </div> -->
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
export default {
  name: 'FormUnderwriting',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const checkSelectAge = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const { age_type,age_id,occ_id } = this.formData.nm_pa_list[index]||{}
      if(!occ_id) {
        callback(new Error(this.$t('placeholder.select')))
      }
      if(age_type==1&&!age_id){
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    return {
      formData: {
        // class_id: 25,
        age_id: '',
        occ_id: '',
        plan_tier: 0,
        type_of_insured: 1,
        no_of_adult: 1,
        no_of_child: 1,
        nm_pa_list: []
      },
      visible: false,
      temp_pa: {
        no_of_adult: 1,
        no_of_child: 1,
      },
      popover_adult_visible: false,
      no_of_adult_list: [
        {
          age_type: 1,
          age_id: 0,
          occ_id: 0,
          visible: false,
          showValue: ''
        },
      ],
      no_of_child_list: [
        {
          age_type: 2,
          age_id: '',
          occ_id: '',
          visible: false,
          showValue: ''
        }
      ],
      adult_placeholder: 'Adult Age, Occupation',
      child_placeholder: 'Child Age, Occupation',
      rules:{
        showValue:[
          { validator: checkSelectAge, trigger: ['change'] }
        ],
      }
    }
  },
  computed: {
    paItemDefault(){
      return {
        age_id: '',
        occ_id: ''
      }
    },
    localAllOptions() {
      return this.allOptions27
    },
    type_of_insured_list(){
      return this.localAllOptions.type_of_insured || []
    },
    no_of_pa(){
      return this.temp_pa.no_of_adult + this.temp_pa.no_of_child
    },
    numOfTraveller(){
      const { no_of_adult, no_of_child } = this.formData
      const signAdult = 'Adult(s)'
      const signChild = 'Child(ren)'
      return no_of_child? `${no_of_adult} ${signAdult} · ${no_of_child} ${signChild}` : `${no_of_adult} ${signAdult}`
    },
    occupation(){
      return (type)=>{
        let {child_occupation,occupation  } = this.localAllOptions||{}
        return type==2?child_occupation:occupation
      }
    },
    age(){
      return (type)=>{
        let {adult_age,child_age }= this.localAllOptions||{}
        return type==2?child_age:adult_age
      }
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        Object.keys(this.formData).some(key => {
          if(key in val) {
            this.formData[key] = val[key]
          }
        })
      }
    },
    // no_of_adult_list:{
    //   immediate: true,
    //   deep: true,
    //   handler(val){
    //     this.formData.nm_pa_list = [...val,...this.no_of_child_list]
    //   }
    // },
    // no_of_child_list:{
    //   immediate: true,
    //   deep: true,
    //   handler(val){
    //     this.formData.nm_pa_list = [...this.no_of_adult_list,...val]
    //   }
    // },
    // 'formData.no_of_adult':{
    //   immediate: true,
    //   handler(val){
    //     let adult_length = this.no_of_adult_list.length||0
    //     let obj = {
    //       age_type: 1,
    //       age_id: 0,
    //       occ_id: 0,
    //       visible: false,
    //       showValue: ''
    //     }
    //     if(adult_length<val)
    //       for (var i= adult_length;i<val;i++){
    //         let adult_obj = JSON.parse(JSON.stringify(obj))
    //         this.no_of_adult_list.push(adult_obj)
    //       }
    //     else {
    //       this.no_of_adult_list = this.no_of_adult_list.slice(0,adult_length-val)
    //     }
    //   }
    // },
    // 'formData.no_of_child':{
    //   immediate: true,
    //   handler(val){
    //     let child_length = this.no_of_child_list.length
    //     let obj = {
    //       age_type: 2,
    //       age_id: 0,
    //       occ_id: 1,
    //       visible: false,
    //       showValue: ''
    //     }
    //     if(child_length<val)
    //       for (var i= child_length;i<val;i++){
    //         let child_obj = JSON.parse(JSON.stringify(obj))
    //         this.no_of_child_list.push(child_obj)
    //       }
    //     else {
    //       this.no_of_child_list = this.no_of_child_list.slice(0,child_length-val)
    //     }
    //   }
    // },
  },
  mounted() {
    this.handlerPaList()
  },
  methods: {
    handlerPaList(){
      console.log('handlerPaList')
      const {no_of_adult, no_of_child} = this.temp_pa
      this.formData.no_of_adult = no_of_adult
      this.formData.no_of_child = no_of_child
      this.visible =false
      const { nm_pa_list } = this.formData

      const paList = nm_pa_list || []

      let adultList = paList.filter(v => v.age_type == 1)
      let childList = paList.filter(v => v.age_type == 2)

      let adultLen = adultList.length
      let childtLen = childList.length

      const adultDiff = no_of_adult - adultLen
      if(adultDiff > 0){
        for (let i = 0; i < adultDiff; i++) {
          adultList.push({
            ...this.paItemDefault,
            age_type: 1
          })
        }
      }else if(adultDiff < 0){
        adultList.splice(adultDiff)
      }

      const childDiff = no_of_child - childtLen
      if(childDiff > 0){
        for (let i = 0; i < childDiff; i++) {
          childList.push({
            ...this.paItemDefault,
            age_type: 2,
          })
        }
      }else if(childDiff < 0){
        childList.splice(childDiff)
      }

      let arr = [...adultList,...childList]

      this.formData.nm_pa_list = arr
      this.formData.no_of_pa = Number(no_of_adult) + Number(no_of_child)
    },
    submitForm() {
      // 表單校驗
      this.$refs.form.validate(valid => {
        if(valid) {
          let {type_of_insured} = this.formData||{}
          let params =  JSON.parse(JSON.stringify( this.formData||{}))
          if(type_of_insured==2){
            delete params.age_id
            delete params.occ_id
          }
          this.$emit('getFormData', {
            ...params,
            class_id: 27
          })
        }
      })
    },
    handleConfirm(){

    },
    handleAdultConfirm(item, index){
      let {age_id, occ_id,age_type,visible} = item
      let occ = this.getAllOptionName27(age_type==2?'child_occupation':'occupation', occ_id)
      this.formData.nm_pa_list[index].showValue = `Age ${age_id}  ${occ}`
      this.formData.nm_pa_list[index].visible = false
    },
    handleChangeAge(val,index){
      let {age_id,age_type} = this.formData.nm_pa_list[index]||{}
      if(age_type==2&&age_id>=4){
        this.formData.nm_pa_list[index].occ_id = 246
      }
      if(age_type==2&&age_id<4){
        this.formData.nm_pa_list[index].occ_id = 1
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form-underwriting {
  position: relative;
  // width: 700px;
}
</style>
